export default "__VITE_ASSET__DGfeeVVD__"